import type { CareProtocolOpportunityListItem } from "@elation/api-client/src/stitch-web/models";

import { pluralize } from "@src/shared/utils/strings";

const timeFormatter = new Intl.DateTimeFormat("en-US", {
  hour: "numeric",
  minute: "2-digit",
});

const dateTimeFormatter = new Intl.DateTimeFormat("en-US", {
  month: "short",
  day: "numeric",
  hour: "numeric",
  minute: "2-digit",
});

function startOfDay(date: Date): number {
  return new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
  ).getTime();
}

function uploadTimeLabel(uploadedAtValue: string | null | undefined): string {
  if (!uploadedAtValue) return "Upload date unknown";
  const uploadedAt = new Date(uploadedAtValue);
  if (Number.isNaN(uploadedAt.getTime())) return "Upload date unknown";

  const today = startOfDay(new Date());
  const uploadedDay = startOfDay(uploadedAt);
  const time = timeFormatter.format(uploadedAt);

  if (uploadedDay === today) return `Today, ${time}`;
  if (uploadedDay === today - 86_400_000) return `Yesterday, ${time}`;
  return dateTimeFormatter.format(uploadedAt);
}

export const CareProtocolOpportunityEntity = {
  uploadTimeLabel,

  itemCount(
    careProtocolOpportunities: CareProtocolOpportunityListItem[],
  ): number {
    return careProtocolOpportunities.length;
  },

  patientCount(
    careProtocolOpportunities: CareProtocolOpportunityListItem[],
  ): number {
    return new Set(
      careProtocolOpportunities.map(
        (careProtocolOpportunity) => careProtocolOpportunity.patient.id,
      ),
    ).size;
  },

  itemCountLabel(
    careProtocolOpportunities: CareProtocolOpportunityListItem[],
  ): string {
    return pluralize(
      CareProtocolOpportunityEntity.itemCount(careProtocolOpportunities),
      "item",
    );
  },

  fileCountLabel(fileCount: number): string {
    return pluralize(fileCount, "file");
  },

  patientCountLabel(
    careProtocolOpportunities: CareProtocolOpportunityListItem[],
  ): string {
    return pluralize(
      CareProtocolOpportunityEntity.patientCount(careProtocolOpportunities),
      "patient",
    );
  },
} as const;
